export default "__VITE_ASSET__6m9MMY9j__"